import type {ReactNode} from 'react'
import React from 'react'
import FocusTrap from 'focus-trap-react'
import {ButtonIcons} from '@/_new-code/components/button-icons/button-icon'
import {Button} from '@/_new-code/products/flexible-web-toolkit/components/button/button'

interface ModalProps {
	title?: string
	subtitle: ReactNode
	children?: ReactNode | null
	togglePopup: () => void
}

export const Modal = ({
	title = '',
	subtitle = '',
	children = null,
	togglePopup,
}: ModalProps): React.JSX.Element => (
	<FocusTrap focusTrapOptions={{delayInitialFocus: false}}>
		<div className="fixed left-0 top-0 z-100 flex h-full w-full items-center bg-white-transparent pb-8 pt-16">
			<div className="container-narrow relative max-h-full overflow-auto rounded-lg bg-white shadow-secondary">
				<Button
					as="button"
					className="absolute right-0 top-0 mt-4 block h-10 border-0 bg-white p-3 text-black"
					icon={ButtonIcons.Close}
					onClick={togglePopup}
					variant="transparent"
				/>
				<div className="w-full bg-white px-4 py-8 lg:px-10 lg:py-10">
					<h2 className="mb-6">{title}</h2>
					<div className="content">{subtitle}</div>
					{children}
				</div>
			</div>
		</div>
	</FocusTrap>
)
